<template>
   <!-- :class="pic == 1?'pcbg':'h5bg'" -->
  <div class="home-wrapper">
    <div class="bg">
      <!-- <div :class="pic == 1?'pcbg':'h5bg'"></div> -->
       <img class="top" :src="pic == 1 ? 'https://aweqn.zhiandexpo.com/awe2027pc.jpg' : 'https://aweqn.zhiandexpo.com/awe2027.png'" alt="">
       <div :class="pic == 1 ? 'box' : 'h5box'">
        <img :class="pic == 1 ? 'pcTit' : 'h5Tit'" :src="pic == 1 ? 'https://aweqn.zhiandexpo.com/pc2027.png' : 'https://aweqn.zhiandexpo.com/h52027.png'" alt="">
        <!-- 综合入口 -->
        <div :class="pic == 1 ? 'pcbtnbox' : 'h5btnbox'">
          <div>
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('pc')" src="https://aweqn.zhiandexpo.com/newpc.png" alt="">
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('h5')" src="https://aweqn.zhiandexpo.com/newh5.png" alt="">
          </div>
          <!-- 本届只做新国际展区：东方枢纽入口整体隐藏 -->
          <div v-if="showEastEntry">
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('pc', 1)" src="https://aweqn.zhiandexpo.com/eastpc.png" alt="">
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('h5', 1)" src="https://aweqn.zhiandexpo.com/easth5.png" alt="">
          </div>
        </div>
        <!-- h5入口 -->
        <!-- <div :class="pic == 1 ? 'pcbtnbox' : 'h5btnbox'">
          <div>
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('h5')" src="https://aweqn.zhiandexpo.com/newh5.png" alt="">
          </div>
          <div>
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('h5', 1)" src="https://aweqn.zhiandexpo.com/easth5.png" alt="">
          </div>
        </div> -->
        <!-- 新国际入口 -->
        <!-- <div :class="pic == 1 ? 'pcbtnbox' : 'h5btnbox'">
          <div>
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('pc')" src="https://aweqn.zhiandexpo.com/newpc.png" alt="">
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('h5')" src="https://aweqn.zhiandexpo.com/newh5.png" alt="">
          </div>
        </div> -->
        <!-- 东方枢纽入口 -->
        <!-- <div :class="pic == 1 ? 'pcbtnbox' : 'h5btnbox'">
          <div>
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('pc', 1)" src="https://aweqn.zhiandexpo.com/eastpc.png" alt="">
            <img :class="pic == 1 ? 'pcbtn' : 'h5btn'" @click="link('h5', 1)" src="https://aweqn.zhiandexpo.com/easth5.png" alt="">
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info:{},
      pic:1,
      channel_id:'',
      // 本届只做新国际展区：东方枢纽入口整体隐藏。
      // 恢复时把 showEastEntry 改回 true 即可，其余逻辑无需改动。
      showEastEntry: false
    }
  },
  mounted(){
    console.log(this.$route.query.id)
    if(this.$route.query.channel_id){
      this.channel_id = this.$route.query.channel_id
    }
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("iphone") > 0 || ua.indexOf("android") > 0 || ua.indexOf("android") > 0) {
      // window.location.href = "http://m.innotebox.com";
      this.pic = 2
    }else{
      this.pic = 1
    }
  },
  methods: {
    // 正式环境把页面域名里的 test 去掉(awebmtest→awebm)；测试/本地原样。配合打一次包正式/测试通用。
    envUrl(u) {
      var h = (typeof location !== 'undefined' && location.hostname) || '';
      var isTest = !h || /test/i.test(h) || h === 'localhost' || h === '127.0.0.1' || /^(192\.168\.|10\.|172\.(1[6-9]|2\d|3[01])\.)/.test(h);
      return isTest ? u : u.replace('test.zhiandexpo.com', '.zhiandexpo.com');
    },
    link(v, type){
      if (type === 1) {
        if(v == 'pc'){
          window.location.href = this.envUrl("https://awesngbmtest.zhiandexpo.com/form?channel_id="+this.channel_id);
        }else{
          window.location.href = this.envUrl("https://awesngbmmtest.zhiandexpo.com?channel_id="+this.channel_id);
        }
      } else {
        if(v == 'pc'){
          window.location.href = this.envUrl("https://awebmtest.zhiandexpo.com/form?channel_id="+this.channel_id);
        }else{
          window.location.href = this.envUrl("https://awebmmtest.zhiandexpo.com?channel_id="+this.channel_id);
        }
      }
    }
  }
}
</script>



<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box; /* 让padding/border不额外增加宽度 */
}

html, body {
  width: 100%;   /* 替换 100vw */
  height: 100vh;
  overflow-x: hidden; /* 兜底：强制隐藏横向滚动条 */
}

.home-wrapper, .bg {
  width: 100%;   /* 替换 100vw */
  height: 100vh;
}
.top {
  width: 100vw;
}
.box {
  display: flex;
  justify-content: center;
}
.h5box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.pcTit {
  width: 643px;
  height: 400px;
  margin-right: 41px;
  margin-top: -19px;
}
.h5Tit {
  width: 261px;
  height: 162px;
  margin-top: -18px;
}
.pcbtnbox {
  margin-top: 40px;
}
.h5btnbox {
  margin-top: -21px;
}
.pcbtn {
  width: 228px;
  height: 228px;
}
.h5btn {
  width: 135px;
  height: 135px;
}
</style>


// WEBPACK FOOTER //
// src/views/home/index.vue